var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { proxyApi, proxyRequest } from './';
import { config } from '..';
/** 自定义的状态管理属性 */
export var LogStatus;
(function (LogStatus) {
    LogStatus[LogStatus["pending"] = 0] = "pending";
    LogStatus[LogStatus["fullfilled"] = 1] = "fullfilled";
    LogStatus[LogStatus["reject"] = 2] = "reject";
})(LogStatus || (LogStatus = {}));
/**
 * 工单 的代理接口
 * @description 系统业务流模块的暴露接口
 * @export
 * @param {string} target 请求路由
 * @param {*} [data] 请求参数
 */
export function ticketApi(target, data, freeLogin) {
    return config.proxyRequest ? proxyRequest({ module: 'ticket', target, data }) : proxyApi({ module: 'ticket', target, data, freeLogin });
}
/**
 * 同步聊天未读消息数
 * @param {string} staffId
 * @param {Record<string,string>} nextLogs {ticketNumber:logId}
 */
export function SyncHistory(params) {
    return ticketApi('logTrace', params);
}
/**
 * 查询审核工单
 * @description staffId：通过`员工`拉取时的员工id；通过账号拉取不需要传递该参数
 * @export
 * @param {(ListPagination & CommonTicketListOption & { staffId?: string, all?: boolean })} params
 */
export function GetAuditList(params) { return ticketApi('auditList', params); }
/**
 * 查询工单提交记录
 * @export
 * @param {(ListPagination & CommonTicketListOption)} params
 */
export function GetSubmitList(params) { return ticketApi('submitList', params); }
/**
 * 查询子工单
 * @param {{projectId:string,ticketNumber:string,childrenProjectId:string}} {
 *     projectId,
 *     ticketNumber,
 *     childrenProjectId
 * }
 */
export function GetChildrentTickets({ projectId, ticketNumber, childrenProjectId }) {
    return ticketApi('childrenTicket', {
        projectId,
        ticketNumber,
        childrenProjectId
    });
}
/**
 * 工单详情
 * @remark 第一次可通过`withLogs:true`全量获取，后续查询通过`GetNewLogs`查询后续记录
 * @export
 * @param {{ projectId: string, ticketNumber: string, withLogs: boolean, logTypes?: string[] }} params
 */
export function GetTicketDetail(params) { return ticketApi('detail', params); }
/**
 * 获取新l工单og
 * @description 通过最近的一条log.id拉取之后的log，相比于全量拉取可以节省开销，一般用于聊天列表
 * @param {{ projectId: string, ticketNumber: string, nextLog: string, staffId: string, logTypes?: string[] }} params
 * @return {*}  {Promise<Logs>}
 */
export function GetNewLogs(params) { return ticketApi('newLogs', params); }
/**
 * 工单聊天的新回复数量
 * @description 根据log.id查询之后有几条记录，一般用于列表的未读数
 * @reamrk nextLogId的存储，离开工单后将本地的nextLogid更新为最新的logid，在列表处通过记录的id查询未读log数量，
 */
export function GetNewLogNumber(params) { return ticketApi('newLogNumbers', params); }
/**
 * 查询工单模块参数
 * @export
 * @param {string} projectId
 */
export function GetProjectDetail(projectId) { return ticketApi('project', { projectId }); }
/**
 * 查询工单可变更状态
 * @export
 * @param {string} projectId
 * @param {string} ticketNumber
 */
export function GetAvailableStatus(projectId, ticketNumber) { return ticketApi('available', { projectId, ticketNumber }); }
/**
 * 流转工单
 * @description 可用于节点/审核人的变更，传空则根据场景设置自动变更
 * @export
 * @param {{ projectId: string, ticketNumber: string, statusId?: string, auditorIds?: string[], staffId?: string, remark?: string }} form
 */
export function PutTransition(form) { return ticketApi('transition', form); }
/**
 * 查询工单用户角色
 * @description 一般不会变，缓存着
 * @export
 * @param {string} projectId
 */
export function GetRole(projectId) { return ticketApi('role', { projectId }, 0); }
/**
 * 回复工单
 * @description 用于聊天
 * @export
 * @param {({ projectId: string, ticketNumber: string, staffId?: string } & ReplyContent)} params
 */
export function Reply(params) { return ticketApi('reply', params); }
/**
 * 获取上传签名
 * @description 上传的文件为私密文件通过`GetPrivateFile`查询，需要预先存好key
 * @export
 * @param {string} projectId
 * @param {string} ticketNumber
 * @param {string} [contentType]
 */
export function GetUploadSignature(projectId, ticketNumber, contentType, isPrivate = true) {
    return ticketApi('upload', {
        projectId,
        ticketNumber,
        parameters: {
            contentType,
            private: isPrivate
        }
    });
}
/**
 * 获取上传资源的签名链接
 * @description 一段时间后链接失效，需要重新获取
 * @export
 * @param {string} projectId
 * @param {string} ticketNumber
 * @param {string} fileId upload.key
 */
export function GetPrivateFile(projectId, ticketNumber, fileId) {
    return ticketApi('privateFile', {
        projectId,
        ticketNumber,
        fileId
    });
}
/**
 * 发送报告到指定邮箱
 * @param {{ projectId: string, staffId: string, statusIds: string[], report: ExportTicketReportOptions }} config
 * @return {*}
 */
export function ExportReport(config) {
    return __awaiter(this, void 0, void 0, function* () {
        return yield ticketApi('report', config);
    });
}
/**
 * 获取工单所有场景下对应角色的员工
 * @export
 * @param {string} projectId
 * @param {string} role 角色名称
 */
export function GetAvailableAuditor(projectId, role) { return ticketApi('availableAuditor', { projectId, role }); }
/**
 * 修改工单Parameters中的商品
 * @description name为工单parameters.name value为parameters.value
 * @export
 * @param {({ projectId: string, ticketNumber: string, staffId?: string, name: string, parameters?: Record<string, string | number> })} params
 */
export function ChangeGoodParameters(params) { return ticketApi('change', params); }
/**
 * 修改工单Parameters中除商品外的参数
 * @description name为工单parameters.name value为parameters.value
 * @export
 * @param {({ projectId: string, ticketNumber: string, staffId?: string, parameters: Record<string, string | number> })} params
 */
export function ChangeParameters(params) { return ticketApi('changes', params); }
/**
 * 根据参数重新指派负责人
 * @description 先`ChangeParameters`变更参数后调用接口进行重新分配
 * @param {string} projectId
 * @param {string} ticketNumber
 * @param {string} staffId
 */
export function Reassign(projectId, ticketNumber, staffId) {
    return ticketApi('reassign', { projectId, ticketNumber, staffId });
}
/**
 * 获取当前员工的所有相关工单项目
 * @param {string} staffId
 */
export function GetAuditProjects(staffId) {
    return ticketApi('auditProjects', { staffId });
}
/**
 * 获取部门信息
 */
export function GetTeamInfo() {
    return ticketApi('teamInfo');
}
/**
 * 获取工单审核角色信息
 */
export function GetTicketAuditor(params) {
    return ticketApi('auditor', params);
}
/**
 * 获取审核者工单节点未读消息数
 */
export function GetTicketAuditStatusCount(params) {
    return ticketApi('auditStatusCount', params);
}
/**
 * 获取提交者工单节点未读消息数
 */
export function GetTicketSubmitStatusCount(params) {
    return ticketApi('submitStatusCount', params);
}
